// extracted by mini-css-extract-plugin
export var table = "_v5-0";